import React from 'react'
import InfoIcon from '@mui/icons-material/Info';
import AdxToolTip from 'components/custom/AdxToolTip';

const AdxInfoIcon = ({sx, toolTipTitle, ...rest}) => {
return (
    <AdxToolTip title={toolTipTitle} placement="bottom">
        <InfoIcon color="information" sx={{fontSize:"16px", ...sx}} {...rest}/>
    </AdxToolTip>
)
}

export default AdxInfoIcon